import { AccountService } from './../service/account.service';
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from "@angular/router";
import { AzureAuthService } from 'src/app/service/azure-auth.service';


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {


  form!: FormGroup;
  login = {
    vc_login: '',
    vc_senha: '',
  }

  public mensagem!: any;
  public minhavariaevl = 0;
  senhaInvalida = 0;
  mostrarSenha = false;
  desabilitaBotao: boolean = false;
  desabilitaBotaoAzure: boolean = false;
  isAzureLoginIsFail: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private azureService: AzureAuthService,
    private route: ActivatedRoute,
    private router: Router,

  ) {
    this.form = this.formBuilder.group({
      vc_login: new FormControl('', [Validators.required]),
      vc_senha: new FormControl('', [Validators.required]),
      recaptcha: new FormControl('', [Validators.required])
    })
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const azureAdLoginFail = params['azure_login_fail'];
      if(azureAdLoginFail === 'true'){
        Swal.fire({
          icon: 'warning',
          title: 'Falha ao logar pela conta Microsoft Azure. Entre em contato com o suporte',
          showConfirmButton: true
        })
      }
      if (token) {
        this.azureService.saveToken(token);
        this.router.navigate(['/home']);
      }
    });
  }

  // public send(form2: NgForm): void {
  //   console.log(form2.invalid)
  //   if (form2.invalid) {
  //     for (const control of Object.keys(form2.controls)) {
  //       form2.controls[control].markAsTouched();
  //     }
  //     return;
  //   }

  // }
  resolved(captchaResponse: string) {
    this.desabilitaBotao = false
    this.senhaInvalida = 2
  }

  errored(captchaResponse: any) {
  }

  async onSubmit() {
    try {
      this.desabilitaBotao = true;
      const resultado = await this.accountService.loginService(this.form.value);
      this.router.navigate(['home/']);
    } catch (error: any) {
      this.desabilitaBotao = false;
      if (error.error.mensagem == 'Senha inválida' || error.error.mensagem == 'E-mail inválido') {
        this.mensagem = error.error.mensagem
        this.minhavariaevl = 1;
        this.senhaInvalida++
        if (this.senhaInvalida > 2) {
          this.desabilitaBotao = true
        }
      }

    };
  }

  public loginAzure(): void {
    this.desabilitaBotaoAzure = true;
    this.azureService.loginService();
  }
}






